import { render } from "./DashboardLayout.vue?vue&type=template&id=37e048ed&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=37e048ed&scoped=true&lang=css"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e048ed"]])

export default __exports__